<div class="item-container">
    <div class="item-header">
        <h5 class="text-center">{{"RECRUITER.SETTINGS" | translate}} </h5>
        <div class="edit-icons" (click)="onCancel()">
            <i class="material-icons">close</i>
        </div>
    </div>
    <div class="item-content d-flex flex-column pt-4">
        <div class="d-flex  flex-grow-1">
            <div class="tab-c">
                <div *ngFor="let item of settingsArr" class="set-tab"
                    [ngClass]="item.name==selectedSetting.name ? 'active-sett' :''" (click)="onSelectedSettings(item)">
                    {{item.name}}
                </div>
            </div>
            <div class="flex-grow-1 ps-3 ps-md-4">
                <div class="min-w-370" *ngIf="selectedSetting.id==0">
                    <mat-checkbox name="schedule" [(ngModel)]="generalObj.enable_unavailability.selected">
                        <div class="text-wrap"> Enable Availability</div>
                    </mat-checkbox>
                    <div class="en-txt en-ava">Users will be able to mark when they’re unavailable to work
                        *Admins will still have the ability to assign shifts to users even if marked as unavailable
                    </div>
                    <div class="d-flex mt-3 btn-div" *ngIf="generalObj.enable_unavailability.selected">
                        <mat-radio-group class="mt-3 d-flex flex-column rd-box" [(ngModel)]="generalObj.unavailability_val" >
                            <div class="d-flex">
                                <mat-radio-button class="" value="unavailability"></mat-radio-button>
                                <div>
                                    <div class="radio-title l-h">Users mark unavailability</div>
                                    <div class="en-txt pt-2">
                                        Users can mark when they’re unavailable. Unmarked days mean they’re available to work
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex rd-l mt-2">
                                <mat-radio-button class="" value="unavailability_prefer"></mat-radio-button>
                                <div>
                                    <div class="radio-title l-h">Users mark unavailability and when they prefer to work </div>
                                    <div class="en-txt pt-2">
                                        Users can mark when they’re unavailable and when they prefer to work.
                                        Unmarked days mean they’re available to work and have no specific preference
                                    </div>
                                </div>
                            </div>
                        </mat-radio-group>
                    </div>
                    <div class="border-t"></div>
                    <div class="">
                        <mat-checkbox name="schedule" [(ngModel)]="generalObj.enable_shift_replacement.selected">
                            <div class="text-wrap"> Enable Shift replacement requests</div>
                        </mat-checkbox>
                        <div class="en-txt en-ava">Users will be able to ask other users to replace them in shifts</div>
                        <div class="en-ava">
                            <mat-checkbox name="schedule" [(ngModel)]="generalObj.shift_replacement.selected"> 
                                <div class="text-wrap">Replacements requires admin approval</div>
                            </mat-checkbox>
                            <div class="en-txt en-ava">When users request to replace shifts it’ll be displayed in the
                                admin scheduler, an admin must approve for it to take effect</div>
                        </div>
                        <div class="border-t"></div>
                        <div class="mt-2">Users can view</div>
                        <div class="mt-2">
                            <mat-checkbox name="schedule"  [(ngModel)]="generalObj.who_created_shift.selected">
                                <div class="text-wrap grey2"> Who created the shift</div>
                            </mat-checkbox>
                        </div>
                        <div class="mt-2">
                            <mat-checkbox name="schedule" [(ngModel)]="generalObj.who_assign_shift.selected">
                                <div class="text-wrap grey2"> Who assigned the shift to them</div>
                            </mat-checkbox>
                        </div>
                        <div class="mt-2">
                            <mat-checkbox name="schedule" [(ngModel)]="generalObj.who_publish_shift.selected">
                                <div class="text-wrap grey2"> Who published the shift to them</div>
                            </mat-checkbox>
                        </div>
                    </div>
                </div>
                <div *ngIf="selectedSetting.id==1">
                    <div class="d-flex align-items-center not-txt">
                        <div class="not-heading">
                            <h6 class="mb-0">Get notified when users:</h6>
                        </div>
                        <div class="slide-1">Mobile</div>
                        <div class="slide-2">Email</div>
                    </div>
                    <div class="d-flex align-items-center not-txt" *ngFor="let item of notificationArr">
                        <div class="not-heading">
                            {{item.name}} 
                            <span *ngIf="item.type=='input'" class="d-flex align-items-center">
                                <input type="number" class="form-control tx-box" [(ngModel)]="item.value"> minutes ago
                            </span>
                        </div>
                        <mat-slide-toggle color="primary" class="mb-0 slide-1" [checked]="item.mobile == 1" (change)="onChange($event,item,'mobile')"></mat-slide-toggle>
                        <mat-slide-toggle color="primary" class="mb-0 slide-2" [checked]="item.email == 1"  (change)="onChange($event,item,'email')"></mat-slide-toggle>
                    </div>
                </div>
                <div *ngIf="selectedSetting.id==2">
                    <h6 class="mb-0">User limitations </h6>
                    <div class="d-flex align-items-center mt-3" *ngFor="let item of userLimitationArr">
                        <div class="not-heading"> 
                            <mat-checkbox name="schedule" [(ngModel)]="item.selected">
                                <div class="text-wrap ">{{item.name}}</div>
                            </mat-checkbox>
                        </div>
                        <div class="d-flex align-items-center" *ngIf="item.type=='custom'">
                            <div> <input type="number" class="me-3 form-control tx-box"  [(ngModel)]="item.value" [disabled]="!item.selected"> </div>
                            <div class="me-3">
                                <mat-select class="form-control" style="min-width:100px"  [(ngModel)]="item.hmd" [disabled]="!item.selected">
                                    <mat-option *ngFor="let item of durationArr" [value]="item.value">{{item.key}}</mat-option>                                                                        
                                </mat-select>
                            </div>
                            <div>Before it starts</div>
                        </div>
                    </div>
                    <div class="border-t"></div>
                    <h6 class="mb-0">Scheduler limitations </h6>
                    <div class="d-flex align-items-center mt-3" *ngFor="let item of schedulerLimitationArr">
                        <div class="not-heading"> 
                            <mat-checkbox name="schedule" [(ngModel)]="item.selected">
                                <div class="text-wrap ">{{item.name}}</div>
                            </mat-checkbox>
                        </div>
                        <div class="d-flex align-items-center">
                            <input type="number" class="me-2 form-control tx-box" [(ngModel)]="item.value" [disabled]="!item.selected"> {{item.type}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="item-footer pt-4">
        <button mat-raised-button color="primary" class="auth-form-btn" type="submit" (click)="onSubmit()">{{"BUTTON.SAVE" | translate }}</button>
    </div>
</div>
<app-loading-spinner></app-loading-spinner>